module.exports = __webpack_public_path__ + "static/img/help.79292b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/help.png
// module id = 9FSi
// module chunks = 1